import { getListingPrice, type ListingPriceDescriptor } from '@pkgs/components/utils/listingDataUtils';
import { DEFAULT_OPTIONS } from '@pkgs/api/utils/filters';
import { type Currency, type Language, type PricesV2, type SearchListing, type UserAccountExclusiveListing } from '@pkgs/api';

type PriceDetails = {
  labelTranslationKey?: ListingPriceDescriptor['labelKey'];
  value?: string;
  priceJsonLdFormattedValue?: string;
  hasPriceOnRequest?: boolean;
};

export const getPriceDetailsBySettings = (
  property: SearchListing | UserAccountExclusiveListing,
  priceObject: PricesV2,
  language: Language,
  currency: Currency,
): PriceDetails => {
  const priceDescriptor = getListingPrice(
    {
      ...property,
      baseCurrency: currency,
      basePrice: priceObject,
      price: undefined,
    },
    { currency, language },
  );
  if (priceDescriptor.valueKey) {
    return { hasPriceOnRequest: true, labelTranslationKey: priceDescriptor.labelKey };
  }

  const priceValue = priceObject[priceDescriptor.fieldName]?.min ?? priceObject[priceDescriptor.fieldName]?.max;
  return {
    value: priceDescriptor.value,
    labelTranslationKey: priceDescriptor.labelKey,
    ...(priceValue && {
      priceJsonLdFormattedValue: new Intl.NumberFormat(DEFAULT_OPTIONS.language, { useGrouping: false }).format(priceValue),
    }),
  };
};
